import { ArrowRightIcon } from "@kds-web/icons";
import clsx from "clsx";
import { useState } from "react";
import type { JSX } from "react/jsx-runtime";
import type { DropdownFilter } from "./Dropdown";

type Props = {
  onFilterSelect: (filter: DropdownFilter) => void;
  filters: DropdownFilter[];
  parentActiveIndex: number;
  childActiveIndex: number;
  listId: string;
};

function DropdownList({
  filters,
  onFilterSelect,
  parentActiveIndex,
  childActiveIndex,
  listId,
}: Props): JSX.Element {
  const [hoveredIndex, setHoveredIndex] = useState(-1);

  return (
    <ul
      id={listId}
      className="absolute top-full z-dropdown mt-[19px] w-max rounded-medium bg-surface py-xxsmall shadow-elevation"
      role="listbox"
    >
      {filters.map((filter, index) => (
        <li
          key={filter.value}
          id={`${listId}-${index}`}
          role="option"
          aria-selected={parentActiveIndex === index && childActiveIndex < 0}
          aria-label={filter.name} // Used to avoid screen reader reading the whole submenu
          onMouseDown={() => onFilterSelect(filter)}
          className={clsx(
            "relative flex cursor-pointer items-center justify-between text-nowrap p-xxsmall pl-large pr-xsmall text-onSurface hover:bg-surfaceSubdued",
            parentActiveIndex === index &&
              childActiveIndex < 0 &&
              "bg-surfaceSubdued",
          )}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(-1)}
        >
          {filter.name}
          {filter.children && filter.children.length > 0 ? (
            <ArrowRightIcon size="small" className="ml-xsmall" />
          ) : null}
          {filter.children &&
          filter.children.length > 0 &&
          (parentActiveIndex === index || hoveredIndex === index) ? (
            <ul className="absolute left-full top-none z-dropdown w-max rounded-medium bg-surface py-xxsmall shadow-elevation">
              {filter.children.map((childElement, childIndex) => (
                <li
                  id={`${listId}-${index}-${childIndex}`}
                  className={clsx(
                    "cursor-pointer text-nowrap p-xxsmall pl-large pr-xsmall text-onSurface hover:bg-surfaceSubdued",
                    childActiveIndex === childIndex && "bg-surfaceSubdued",
                  )}
                  key={childElement.name}
                  role="option"
                  aria-selected={childActiveIndex === childIndex}
                  onMouseDown={(): void => onFilterSelect(childElement)}
                >
                  {childElement.name}
                </li>
              ))}
            </ul>
          ) : null}
        </li>
      ))}
    </ul>
  );
}

export default DropdownList;
